import React from 'react';
import './OpportunityActions.css';

const OpportunityActions = ({ 
  token, 
  opportunities = [], 
  onQuickBuy, 
  onQuickSell, 
  onAddToBot, 
  onSetAlert,
  userBalance = 0,
  className = '' 
}) => {
  if (!opportunities || opportunities.length === 0) {
    return null;
  }

  const getActionRecommendations = () => {
    const recommendations = [];
    
    opportunities.forEach(opportunity => {
      switch (opportunity.opportunity_type) {
        case 'volume_spike':
          if (opportunity.confidence_score >= 0.7) {
            recommendations.push({
              type: 'buy',
              priority: 'high',
              reason: 'Volume spike detected - potential breakout',
              action: 'Quick Buy',
              confidence: opportunity.confidence_score
            });
          }
          break;
          
        case 'price_breakout':
          if (opportunity.price_change_1h > 0 && opportunity.confidence_score >= 0.6) {
            recommendations.push({
              type: 'buy',
              priority: 'high',
              reason: 'Bullish breakout with volume confirmation',
              action: 'Quick Buy',
              confidence: opportunity.confidence_score
            });
          } else if (opportunity.price_change_1h < 0 && userBalance > 0) {
            recommendations.push({
              type: 'sell',
              priority: 'medium',
              reason: 'Bearish breakout - consider taking profits',
              action: 'Quick Sell',
              confidence: opportunity.confidence_score
            });
          }
          break;
          
        case 'trend_reversal':
          if (opportunity.confidence_score >= 0.6) {
            recommendations.push({
              type: 'bot',
              priority: 'medium',
              reason: 'Trend reversal - good for automated trading',
              action: 'Add to Bot',
              confidence: opportunity.confidence_score
            });
          }
          break;
          
        default:
          if (opportunity.confidence_score >= 0.8) {
            recommendations.push({
              type: 'alert',
              priority: 'low',
              reason: 'High confidence opportunity - set alert',
              action: 'Set Alert',
              confidence: opportunity.confidence_score
            });
          }
      }
    });
    
    // Sort by priority and confidence
    return recommendations.sort((a, b) => {
      const priorityOrder = { high: 3, medium: 2, low: 1 };
      const priorityDiff = priorityOrder[b.priority] - priorityOrder[a.priority];
      if (priorityDiff !== 0) return priorityDiff;
      return b.confidence - a.confidence;
    });
  };

  const recommendations = getActionRecommendations();
  
  if (recommendations.length === 0) {
    return null;
  }

  const handleAction = (recommendation) => {
    switch (recommendation.type) {
      case 'buy':
        onQuickBuy && onQuickBuy(token);
        break;
      case 'sell':
        onQuickSell && onQuickSell(token);
        break;
      case 'bot':
        onAddToBot && onAddToBot(token);
        break;
      case 'alert':
        onSetAlert && onSetAlert(token);
        break;
    }
  };

  const getActionButtonClass = (recommendation) => {
    const baseClass = 'opportunity-action-btn';
    const typeClass = `${baseClass}--${recommendation.type}`;
    const priorityClass = `${baseClass}--${recommendation.priority}`;
    return `${baseClass} ${typeClass} ${priorityClass}`;
  };

  const getActionIcon = (type) => {
    switch (type) {
      case 'buy': return '🚀';
      case 'sell': return '💰';
      case 'bot': return '🤖';
      case 'alert': return '🔔';
      default: return '⚡';
    }
  };

  return (
    <div className={`opportunity-actions ${className}`}>
      <div className="opportunity-actions-header">
        <span className="actions-title">Recommended Actions</span>
        <span className="actions-count">{recommendations.length}</span>
      </div>
      
      <div className="opportunity-actions-list">
        {recommendations.slice(0, 3).map((recommendation, index) => (
          <div
            key={`${recommendation.type}-${index}`}
            className="opportunity-action-item"
          >
            <button
              className={getActionButtonClass(recommendation)}
              onClick={() => handleAction(recommendation)}
              title={recommendation.reason}
            >
              <span className="action-icon">{getActionIcon(recommendation.type)}</span>
              <span className="action-text">{recommendation.action}</span>
              <div className="action-confidence">
                <div 
                  className="confidence-indicator"
                  style={{ width: `${recommendation.confidence * 100}%` }}
                />
              </div>
            </button>
            
            <div className="action-reason">
              {recommendation.reason}
            </div>
          </div>
        ))}
      </div>
      
      {recommendations.length > 3 && (
        <div className="more-actions">
          +{recommendations.length - 3} more recommendations
        </div>
      )}
    </div>
  );
};

export default OpportunityActions;